export const commandDataList = [
	{
		id: 0,
		name: 'Victoria Egorova',
		post: 'Senior Frontend Developer',
		image: ''
	},
	{
		id: 1,
		name: 'Ivan Krylov',
		post: 'Senior Software Engineer',
		image: ''
	},
	{
		id: 2,
		name: 'Nikita Snitko',
		post: 'Middle Frontend Developer',
		image: ''
	},
	{
		id: 3,
		name: 'Alexander Matyushev',
		post: 'Full Stack Developer',
		image: ''
	},
	{
		id: 4,
		name: 'Viktor Semyonov',
		post: 'Web-3 Software Engineer',
		image: ''
	},
	{
		id: 5,
		name: 'Nikolai Klimenko',
		post: 'Social Media Manager',
		image: ''
	},
	{
		id: 6,
		name: 'Anton Kunakhovets',
		post: 'UX/UI Designer',
		image: ''
	},
	{
		id: 7,
		name: 'Tatiana Ivanova',
		post: 'Community manager',
		image: ''
	},
	{
		id: 8,
		name: 'Denis Kimerov',
		post: 'Community manager',
		image: ''
	},
	{
		id: 9,
		name: 'Alexander Belitsky',
		post: 'Editor - Content Manager',
		image: ''
	},
	{
		id: 10,
		name: 'Viktor Nesterenko',
		post: 'Analyst - Content Manager',
		image: ''
	},
	{
		id: 11,
		name: 'Jan Tereshkov',
		post: 'Analyst - Content Manager',
		image: ''
	},

]

export 	const openPositions:{id:number, title:string, position:string, description:string}[] = [
	// {
	// 	id: 1,
	// 	title: 'Middle Frontend Developer',
	// 	position: 'React, Typescript, Electron',
	// 	description: 'Development of a cross-platform application for the Web3 ecosystem. The application is a PC software for managing digital assets, including cryptocurrencies and airdrop farming automation. The application developed using React, Typescript, and Electron.',
	// },
];
